import { Coins, Gift, ArrowRight } from "lucide-react";
import { useAuth } from "@/auth";
import { useLang } from "@/i18n";

export default function WelcomeBonusModal({ onCollection }) {
  const { welcomeBonus, clearWelcomeBonus } = useAuth();
  const { t } = useLang();
  if (!welcomeBonus) return null;

  const goCollection = () => { clearWelcomeBonus(); onCollection?.(); };

  return (
    <div
      data-testid="welcome-bonus-modal"
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={clearWelcomeBonus}
    >
      <div
        className="pixel-card bg-[#111] text-white w-full max-w-md p-6 sm:p-8 text-center relative"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto w-16 h-16 rounded-full bg-[#4CAF50] flex items-center justify-center ring-4 ring-white/20 shadow-lg">
          <Gift size={34} strokeWidth={2.5} className="text-white" />
        </div>
        <h2 className="font-pixel text-lg sm:text-2xl text-[#FFEB3B] pixel-stroke mt-4">{t("welcomeBonusTitle")}</h2>
        <div
          data-testid="welcome-bonus-amount"
          className="mx-auto mt-4 inline-flex items-center gap-2.5 px-5 py-2.5 rounded-2xl bg-black/50 ring-2 ring-[#FFB300]/70 font-pixel text-2xl text-[#FFB300]"
        >
          <Coins size={30} strokeWidth={2.5} /> +{welcomeBonus}
        </div>
        <p className="font-vt text-lg sm:text-xl text-white/85 mt-4 leading-tight">{t("welcomeBonusBody")(welcomeBonus)}</p>
        <button
          data-testid="welcome-bonus-collection-btn"
          onClick={goCollection}
          className="pixel-btn bg-[#FFD400] text-black w-full mt-6 px-4 py-4 text-sm sm:text-base flex items-center justify-center gap-2"
        >
          {t("welcomeBonusCta")} <ArrowRight size={18} strokeWidth={3} />
        </button>
        <button
          data-testid="welcome-bonus-dismiss-btn"
          onClick={clearWelcomeBonus}
          className="font-vt text-white/70 underline text-base mt-3 hover:text-white"
        >
          {t("welcomeBonusDismiss")}
        </button>
      </div>
    </div>
  );
}
